const React = require('react')
const { useState } = require('react')
const { Card, CardHeader, CardBody, Collapse, Row, Col, FormGroup, Label, Input } = require('reactstrap')

const { useNetworkConfig } = require('@contexts')

require('@styles/pages/verifyContract/index.css')

const Library = () => {
    const { network } = useNetworkConfig()

    const [isContractLibraryOpen, setIsContractLibraryOpen] = useState(false)

    const [libraries, setLibraries] = useState([{ name: '', address: '' }])

    const handleLibraryNameChange = (index, value) => {
        const newLibraries = [...libraries]
        newLibraries[index].name = value
        setLibraries(newLibraries)
    }

    const handleLibraryAddressChange = (index, value) => {
        const newLibraries = [...libraries]
        newLibraries[index].address = value
        setLibraries(newLibraries)
    }

    const addLibrary = () => {
        setLibraries([...libraries, { name: '', address: '' }])
    }

    const removeLibrary = index => {
        const newLibraries = libraries.filter((_, i) => i !== index)
        setLibraries(newLibraries)
    }

    return (
        <Card className='box table-section' style={{ padding: '0px', border: 'none' }}>
            <CardHeader
                className='verify-card-header cursor-pointer'
                onClick={() => setIsContractLibraryOpen(!isContractLibraryOpen)}
                style={{
                    border: !isContractLibraryOpen && 'none',
                    borderColor: isContractLibraryOpen && 'var(--dropdown-background)'
                }}
            >
                <span style={{ fontWeight: 'bold' }}>
                    Contract Library Address&nbsp;
                    <span style={{ color: 'var(--grey-color)' }}>
                        (for contracts that use libraries, supports up to 10 libraries)
                    </span>
                </span>
                <i className={`fas fa-angle-${isContractLibraryOpen ? 'up' : 'down'}`} />
            </CardHeader>
            <Collapse isOpen={isContractLibraryOpen}>
                <CardBody>
                    <div>Note: Library names are case sensitive and affects the keccak library hash</div>
                    <div
                        className={`${network.name}-text-color cursor-pointer`}
                        onClick={addLibrary}
                        style={{ margin: '16px 0' }}
                    >
                        + Add Library
                    </div>
                    {libraries.map((library, index) => (
                        <div
                            key={index}
                            style={{
                                backgroundColor: 'var(--dropdown-background)',
                                borderRadius: '8px',
                                padding: '16px 16px 0 16px',
                                marginBottom: index < libraries.length - 1 ? '16px' : '0',
                                position: 'relative'
                            }}
                        >
                            {index > 0 && (
                                <div
                                    className={`${network.name}-text-color cursor-pointer`}
                                    onClick={() => removeLibrary(index)}
                                    style={{
                                        position: 'absolute',
                                        top: '12px',
                                        right: '12px',
                                        fontSize: '14px'
                                    }}
                                >
                                    <i className='fas fa-times' />
                                </div>
                            )}
                            <Row>
                                <Col xs='12' md='4'>
                                    <FormGroup>
                                        <Label>Library Name</Label>
                                        <Input
                                            type='text'
                                            placeholder='Enter library name'
                                            className='verify-contract-input'
                                            value={library.name}
                                            onChange={e => handleLibraryNameChange(index, e.target.value)}
                                            style={{
                                                backgroundColor: 'var(--black-background)',
                                                color: 'var(--white-color)',
                                                border: 'none'
                                            }}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col xs='12' md='8'>
                                    <FormGroup>
                                        <Label>Library Contract Address</Label>
                                        <Input
                                            type='text'
                                            placeholder='0x...'
                                            className='verify-contract-input'
                                            value={library.address}
                                            onChange={e => handleLibraryAddressChange(index, e.target.value)}
                                            style={{
                                                backgroundColor: 'var(--black-background)',
                                                color: 'var(--white-color)',
                                                border: 'none'
                                            }}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </div>
                    ))}
                </CardBody>
            </Collapse>
        </Card>
    )
}

module.exports = { Library }
